import React, { useMemo } from 'react';
import { Box, Heading, Image, VStack } from '@chakra-ui/react';

import config from '@config';
import useIsEn from '@hooks/useIsEn';
import { useTranslation } from 'next-i18next';

export const ChatbotInfo: React.FC<{ info: string }> = ({ info }) => {
  const isEn = useIsEn();
  const { t } = useTranslation('common');
  const data = useMemo(() => {
    try {
      const parsed = JSON.parse(info);
      return config.projectInfo.map((item) => {
        return {
          ...item,
          value: parsed[item.key],
        };
      });
    } catch (err) {
      return [];
    }
  }, [info]);
  const imageUrl = useMemo(() => {
    try {
      const parsed = JSON.parse(info);
      return parsed.imageUrl || '';
    } catch (err) {
      return '';
    }
  }, [info]);
  const shortDescription = useMemo(() => {
    try {
      const parsed = JSON.parse(info);
      return parsed.shortDescription || '';
    } catch (err) {
      return '';
    }
  }, [info]);

  return (
    <VStack align="flex-start">
      {shortDescription && (
        <Box mb="20px">
          <Heading size="md" mb="1">
            {t('Short description')}
            {t('modal.title.selectProject')}
          </Heading>
          <div
            className="infoRender"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: shortDescription }}
            color="black !important"
          />
        </Box>
      )}
      {imageUrl && (
        <Box mb="20px">
          <Heading size="md" mb="1">
            Chat diagram
          </Heading>
          <Image src={imageUrl} />
        </Box>
      )}
      {data.map((item) => (
        <Box key={item.key} mb="20px">
          <Heading size="md" mb="1">
            {isEn ? item.titleEn : item.title}
          </Heading>
          <div
            className="infoRender"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: item.value }}
            color="black !important"
          />
        </Box>
      ))}
    </VStack>
  );
};
